module.exports = __webpack_public_path__ + "img/GH-kyujin-top-013.91467bc1.webp";